module.exports = __webpack_public_path__ + "img/sv1.4ae7c0b1.svg";